module.exports = __webpack_public_path__ + "img/no-image.6d644841.jpg";